var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWalletLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CE6B2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92C0F3",
    offset: "30.6917671%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCCFFE",
    offset: "76.7919917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFAFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u767B\\u9646\\u6837\\u5F0F\\u66F4\\u65B0",
    transform: "translate(-350.000000, -137.000000)",
    fillRule: "nonzero",
    stroke: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6\\u5907\\u4EFD",
    transform: "translate(125.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17",
    transform: "translate(16.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(160.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-twitter",
    transform: "translate(50.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1111111,0 C36.0203089,-9.01805001e-16 40,3.97969111 40,8.88888889 L40,31.1111111 C40,36.0203089 36.0203089,40 31.1111111,40 L8.88888889,40 C3.97969111,40 6.01203334e-16,36.0203089 0,31.1111111 L0,8.88888889 C-6.01203334e-16,3.97969111 3.97969111,9.01805001e-16 8.88888889,0 L31.1111111,0 Z M27.7777778,10 L12.2222222,10 C10.9888889,10 10,11 10,12.2222222 L10,12.2222222 L10,27.7777778 C10,29 10.9888889,30 12.2222222,30 L12.2222222,30 L27.7777778,30 C29,30 30,29 30,27.7777778 L30,27.7777778 L30,26.6666667 L20,26.6666667 C18.7666667,26.6666667 17.7777778,25.6666667 17.7777778,24.4444444 L17.7777778,24.4444444 L17.7777778,15.5555556 C17.7777778,14.3333333 18.7666667,13.3333333 20,13.3333333 L20,13.3333333 L30,13.3333333 L30,12.2222222 C30,11 29,10 27.7777778,10 L27.7777778,10 Z M31.1111111,15.5555556 L20,15.5555556 L20,24.4444444 L31.1111111,24.4444444 L31.1111111,15.5555556 Z M24.4444444,18.3333333 C25.3666667,18.3333333 26.1111111,19.0777778 26.1111111,20 C26.1111111,20.9222222 25.3666667,21.6666667 24.4444444,21.6666667 C23.5222222,21.6666667 22.7777778,20.9222222 22.7777778,20 C22.7777778,19.0777778 23.5222222,18.3333333 24.4444444,18.3333333 Z",
    id: "\\u5F62\\u72B6"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWalletLine);
export default __webpack_public_path__ + "static/media/icon-wallet-line.3d074307f33139ea472c8b8148eb7e33.svg";
export { ForwardRef as ReactComponent };